// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: 'AIzaSyCB3Vvqwl6Wsqls2u_dIAj3K8xFvUzPleA',
    authDomain: 'tasklaw-dashboard.firebaseapp.com',
    projectId: 'tasklaw-dashboard',
    storageBucket: 'tasklaw-dashboard.appspot.com',
    messagingSenderId: '480992252426',
    appId: '1:480992252426:web:7a51e9d6f6044a9ccd85f3',
    measurementId: 'G-82VTSS05FL'
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const Firebase = getAnalytics(app)

export default Firebase
